import { NgModule, isDevMode, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// CDK
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';

// Routes
import { AppRoutingModule } from './app-routing.module';

// Components
import { GenericConfirmDialogComponent } from '@views/global/dialogues/generic-confirm-dialog/generic-confirm-dialog.component';
import { AppComponent } from './app.component';

// Standalone
import { NavbarSComponent } from '@views/global/navbar/navbar.component';
import { LoaderSComponent } from '@views/global/loader/loader.component';
import { FooterSComponent } from '@views/global/footer/footer.component';


// Modules
// import { CoreModule } from './core/core.module';
import { PublicModule } from '@views/public/public.module';
import { SecurityModule } from "@core/providers/services/security/security.module";
import { StoreModule } from "@core/store/store.module";
import { GraphQLModule } from '@core/providers/services/graphql/graphql.module';

// Providers
import { NetworkInterceptor } from '@core/providers/interceptors/network/network.interceptor';
import { SecurityInterceptor } from "@core/providers/interceptors/security/security.interceptor";
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { MatIconModule } from '@angular/material/icon';
import { SidenavSComponent } from './views/global/sidenav/sidenav.component';
import { KeycloakService } from './core/providers/services/security/keycloak/keycloak.service';



@NgModule({
  declarations: [
    AppComponent,
    GenericConfirmDialogComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MatDialogModule,
    MatSnackBarModule,
    SidenavSComponent as any,
    MatDividerModule,
    MatButtonModule,
    SecurityModule,
    StoreModule,
    PublicModule,
    GraphQLModule,
    NavbarSComponent as any, // Standalone
    LoaderSComponent as any, // Standalone
    FooterSComponent as any, // Standalone
  ],
  providers: [
    // { provide: MatDialogRef, useValue: { } },
    // { provide: MAT_DIALOG_DATA, useValue: { } },
    {
      provide: APP_INITIALIZER,
      useFactory: (keycloak: KeycloakService)  => () => keycloak.init(),
      deps: [ KeycloakService ],
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: NetworkInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SecurityInterceptor, multi: true },
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
